import { Facebook } from "lucide-react";
import { BUSINESS, FACEBOOK_URL } from "@/lib/site";
import { Reveal } from "../Reveal";

export function SocialSection() {
  return (
    <section className="texture-paper bg-background py-20 sm:py-24" aria-labelledby="social-title">
      <div className="mx-auto max-w-[1400px] px-4 text-center sm:px-6 lg:px-10">
        <Reveal>
          <h2
            id="social-title"
            className="font-display text-3xl leading-tight text-forest-deep sm:text-4xl"
          >
            Connect With Amigo Inn
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-muted-foreground">
            Follow {BUSINESS.name} on Facebook for park updates and community moments.
          </p>
          <a
            href={FACEBOOK_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-8 inline-flex min-h-12 items-center gap-3 rounded-sm border border-forest/25 px-6 text-sm font-semibold text-forest transition-colors hover:bg-forest hover:text-primary-foreground"
            aria-label={`${BUSINESS.name} on Facebook`}
          >
            <Facebook className="size-4" aria-hidden="true" />
            Visit Us on Facebook
          </a>
        </Reveal>
      </div>
    </section>
  );
}
